var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { forwardRef } from 'react';
import BraintreeCreditCard from './Braintree/CreditCard';
import AdyenCreditCard from './Adyen/CreditCard';
import { SupportedVendors } from '../../common/Constants';
export var getCardholderNameFromString = function (cardholderName) {
    if (typeof cardholderName === 'string') {
        var nameList = cardholderName.split(' ');
        // last item will always be the lastname
        var lastName = nameList.pop();
        var firstName = nameList.join(' ');
        return { firstName: firstName, lastName: lastName };
    }
    else {
        return cardholderName;
    }
};
var CreditCard = forwardRef(function (props, ref) {
    var _a;
    if (((_a = props.applicationSession) === null || _a === void 0 ? void 0 : _a.vendor) === SupportedVendors.adyen) {
        return React.createElement(AdyenCreditCard, __assign({}, props, { ref: ref }));
    }
    return React.createElement(BraintreeCreditCard, __assign({}, props, { ref: ref }));
});
export default CreditCard;
